/*
 * Generated by graphql-codegen. Do not modify this file manually.
 */

// @ts-ignore Allow unused imports
import type * as Types from '../../../../graphql/schema';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type AccountHolderQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type AccountHolderQuery = { __typename: 'Query', envelopeAccount:
    | { __typename: 'CashAccount', id: string, accountHolders: Array<
        | { __typename: 'Client', id: string }
        | { __typename: 'Trust', id: string }
      > }
    | { __typename: 'DirectTradingAccount', id: string, accountHolders: Array<
        | { __typename: 'Client', id: string }
        | { __typename: 'Trust', id: string }
      > }
    | { __typename: 'ManagedAccount', id: string, accountHolders: Array<
        | { __typename: 'Client', id: string }
        | { __typename: 'Trust', id: string }
      > }
   };


export const AccountHolderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountHolder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"envelopeAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountHolders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Client"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Trust"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountHolderQuery, AccountHolderQueryVariables>;